import { render, staticRenderFns } from "./GuidanceNote.vue?vue&type=template&id=40e4d071&scoped=true"
import script from "./GuidanceNote.vue?vue&type=script&lang=ts"
export * from "./GuidanceNote.vue?vue&type=script&lang=ts"
import style0 from "./GuidanceNote.vue?vue&type=style&index=0&id=40e4d071&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e4d071",
  null
  
)

export default component.exports